import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import { useStyles } from "./CustomEmptyMessage.css";

class CustomEmptyMessage extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        {this.props.description ? (
          <div>{this.props.description}</div>
        ) : (
          <div>There is no any data present in the database</div>
        )}
      </div>
    );
  }
}

export default withStyles(useStyles)(CustomEmptyMessage);
